import { Component, input } from '@angular/core';

import { PrivaLocalizationModule } from '@priva/localization';

@Component({
    selector: 'app-tile-list-separator',
    templateUrl: './tile-list-separator.component.html',
    styleUrl: './tile-list-separator.component.scss',
    imports: [PrivaLocalizationModule],
})
export class TileListSeparatorComponent {
    label = input('');
}
